// import ExhibitionsHome from '../views/exhibitions/ExhibitionsHome';
import Modex2026 from '../views/exhibitions/Modex2026';
import RetailTechShow2026 from '../views/exhibitions/RetailTechShow2026';
import SatoPartnerDay2026 from '../views/exhibitions/SatoPartnerDay2026';
import HomeDeliveryWorld2026 from '../views/exhibitions/HomeDeliveryWorld2026';
import TapaEmea2026 from '../views/exhibitions/TapaEmea2026';
import ParcelForum2026 from '../views/exhibitions/ParcelForum2026';
import { routeNames } from '../constants';

export default [
  {
    path: '/exhibitions',
    redirect: { name: routeNames.home },
    // component: ExhibitionsHome,
    component: () => import(/* webpackChunkName: 'exhibitions' */ '../views/exhibitions/ExhibitionsHome'),
    children: [
      {
        path: 'modex-2026',
        name: routeNames.exhibitions.modex2026,
        component: Modex2026,
        props: (route) => ({ ...route.query, ...route.params, hash: route.hash }),
        meta: {
          allowTokenAuth: true, // allow route to be viewed with token in the URL
          noLayout: true,
        },
      },
      {
        path: 'retail-tech-show-2026',
        name: routeNames.exhibitions.retailTechShow2026,
        component: RetailTechShow2026,
        props: (route) => ({ ...route.query, ...route.params, hash: route.hash }),
        meta: {
          allowTokenAuth: true, // allow route to be viewed with token in the URL
          noLayout: true,
        },
      },
      {
        path: 'sato-partner-day-2026',
        name: routeNames.exhibitions.satoPartnerDay2026,
        component: SatoPartnerDay2026,
        props: (route) => ({ ...route.query, ...route.params, hash: route.hash }),
        meta: {
          allowTokenAuth: true, // allow route to be viewed with token in the URL
          noLayout: true,
        },
      },
      {
        path: 'home-delivery-world-2026',
        name: routeNames.exhibitions.homeDeliveryWorld2026,
        component: HomeDeliveryWorld2026,
        props: (route) => ({ ...route.query, ...route.params, hash: route.hash }),
        meta: {
          allowTokenAuth: true, // allow route to be viewed with token in the URL
          noLayout: true,
        },
      },
      {
        path: 'tapa-emea-2026',
        name: routeNames.exhibitions.tapaEmea2026,
        component: TapaEmea2026,
        props: (route) => ({ ...route.query, ...route.params, hash: route.hash }),
        meta: {
          allowTokenAuth: true, // allow route to be viewed with token in the URL
          noLayout: true,
        },
      },
      {
        path: 'parcel-forum-2026',
        name: routeNames.exhibitions.parcelForum2026,
        component: ParcelForum2026,
        props: (route) => ({ ...route.query, ...route.params, hash: route.hash }),
        meta: {
          allowTokenAuth: true, // allow route to be viewed with token in the URL
          noLayout: true,
        },
      },
    ],
  },
];
